import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IPosPriority } from '../models/models'

export class GetPosPriorityApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/posTransaction/getPosPriority',
      requesterInfo,
    })
  }

  public async getPosPriority(): Promise<IPosPriority[]> {
    return await this.getAsync<IPosPriority[]>()
  }
}